import { useAccountType } from "@js/apps/common/hooks";
import { useFreelancerProfile } from "@js/apps/freelancer/hooks";
import { CompleteProfileStatusBox } from "@js/apps/jobs/components/job-status/freelancer/complete-profile-status";
import type { FreelancerBidListItem, Job } from "@js/types/jobs";

import { EmployerStatus } from "./employer/employer";
import { StatusForFreelancer } from "./freelancer/status-for-freelancer";

type StatusProps = {
  job: Job | null;
  bid: FreelancerBidListItem | undefined;
  className?: string;
  longTile?: boolean;
};

export const JobStatus = ({
  job,
  bid,
  longTile,
  className,
  ...props
}: StatusProps) => {
  const { isEmployer } = useAccountType();
  const freelancerProfile = useFreelancerProfile();
  const canBid = freelancerProfile?.can_bid;

  if (
    job?.status_for_freelancer ===
      ENUMS.JobFreelancerStatus.ACCEPTING_APPLICATIONS &&
    !canBid
  ) {
    return <CompleteProfileStatusBox longTile={longTile} />;
  }

  if (isEmployer) {
    return <EmployerStatus job={job} className={className} {...props} />;
  }

  return (
    <StatusForFreelancer
      job={job}
      bid={bid}
      longTile={longTile}
      statusForFreelancer={job?.status_for_freelancer}
      className={className}
      {...props}
    />
  );
};
